import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import CommunityRuleAgreeModal from "./rule-agree-model";
import { setCommunityAndChannel } from "../../../../redux/actions";
import fetcher from "../../../../dataProvider";
import MoreAction from "./more";
import { useRouter } from "next/router";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import get from "lodash/get";
import {
  setShowThread,
  setSelectedThread,
  setThreadDetails,
  setUnreadMessageNotifications,
  setCommunityNameDetails,
  setEventReminder,
  setAnnouncementId,
  setAnnouncementPopupClick,
} from "../../../../redux/slices/community";
import { List, ListItem, Modal, Typography, Link, Button } from "@mui/material";
import moment from "moment";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { IoCopyOutline } from "react-icons/io5";
import { setUserDetail } from "../../../../../src/redux/actions";
import { WEB_URL } from "../../../../constant/appConstants";
import { setUserData } from "../../../../../src/redux/slices/user";
import Slider from "react-slick";
import {
  EmailShareButton,
  FacebookShareButton,
  HatenaShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  TelegramIcon,
  TumblrIcon,
  EmailIcon,
} from "react-share";
import auth from "../../../../../components/Layout/util/auth";
import useCountDown from "../../../../hooks/useCountDown";
import { setDisplayAnnouncement } from "../../../../redux/slices/home";
import { songPageGTMCTAClick } from "../../../../../util/gtmutil";

const useStyles = makeStyles((theme) => ({
  msgOverflowScroll: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "512px",
    background: "#fff",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "& > div": {
      maxHeight: "450px",
      overflowY: "scroll",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    "@media(max-width:767px)": {
      width: "90%",
      padding: "15px",
    },
  },
  invitePopupBox: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "600px",
    background: "#fff",
    margin: "auto",
    borderRadius: "20px",
    top: "50%",
    padding: "15px 30px 0",
    transform: "translateY(-50%)",
    "& > a": {
      position: "absolute",
      top: "15px",
      right: "15px",
      zIndex: "3",
      "@media(max-width:480px)": {
        position: "relative",
        display: "block",
        // marginBottom: "30px",
        left: "93%",
      },
    },
    "@media(max-width:767px)": {
      width: "90%",
      // padding: "15px",
    },
  },
  inviteHeader: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    // marginBottom: "32px",
    padding: "0 30px 10px",
    "& h4": {
      fontSize: "24px",
      fontWeight: "700",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
    },
    "@media(max-width:480px)": {
      // marginBottom: "15px",
      padding: "0 0px 10px",
    },
  },
  inviteBody: {
    position: "relative",
    padding: "0 30px",
    "& > div": {
      position: "relative",
      background: "#e9edfe",
      borderRadius: "10px",
      padding: "18px 20px",
      fontWeight: "500",
      marginBottom: "20px",
      "& span": {
        fontWeight: "500",
        fontSize: "16px",
      },
      "& ul": {
        listStyle: "none",
        fontWeight: "500",
        fontSize: "14px",
        "& li": {
          padding: "2.5px 0 2.5px 23px",
          "&:before": {
            content: "''",
            position: "absolute",
            width: "11px",
            height: "11px",
            top: "10px",
            borderRadius: "50%",
            background: "rgba(52, 84, 250, 0.5)",
            border: "1px solid #3454FA",
            left: "0",
          },
          "&:after": {
            content: "''",
            position: "absolute",
            height: "13px",
            borderLeft: "1px dashed #3454FA",
            left: "5px",
            top: "19px",
          },
        },
        "& li:last-child": {
          fontSize: "16px",
          fontWeight: "500",
        },
        "& li:last-child::after": {
          display: "none",
        },
        "& li:last-child::before": {
          background: "none",
        },
      },
      "@media(max-width:480px)": {
        padding: "10px",
        marginBottom: "10px",
        "& li": {
          "&:after": {
            height: "38px !important",
          },
        },
        "& li:last-child": {
          fontSize: "14px",
        },
      },
    },
    "@media(max-width:480px)": {
      padding: "0",
    },
  },
  inviteFooter: {
    position: "relative",
    padding: "0 30px",
    "& span": {
      color: "rgba(0, 0, 0, 0.54)",
      marginBottom: "8px",
      position: "relative",
      display: "block",
    },
    "@media(max-width:480px)": {
      padding: "0",
    },
  },
  linkContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px",
    border: "1px dashed rgba(0, 0, 0, 0.9)",
    borderRadius: "10px",
    marginBottom: "20px",
    cursor: "pointer",
    "& a": {
      color: "#E14084",
      textDecoration: "underline",
    },
  },
  socialContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    "& > button": {
      marginRight: "5%",
      textAlign: "center",
      marginBottom: "25px",
    },
    "& p": {
      fontSize: "12px",
      color: "rgba(0, 0, 0, 0.75)",
    },
  },
  copied: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    linHeight: "12px",
    color: "#E14084",
    textAlign: "center",
  },
  eventContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "32px",
    "& .slick-slider .slick-dots": {
      display: "flex !important",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
    },
    "& .slick-slider .slick-dots li": {
      margin: "0",
    },
    "& .slick-slider .slick-dots li button:before": {
      fontSize: "6px",
      color: "#fff",
      opacity: "1",
    },
    "& .slick-slider .slick-dots li.slick-active button:before": {
      color: "#e91e63",
      opacity: "1",
    },
  },
  eventReminder: {
    position: "relative",
    display: "block",
    background: "#38316C",
    padding: "13px 13px 0",
    "& img": {
      marginRight: "7px",
      width: "24px",
      height: "24px",
      borderRadius: "50%",
    },
    "& small": {
      fontWeight: "400",
      fontSize: "12px",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      "& img": {
        marginRight: "3px",
      },
    },
    "& p": {
      fontWeight: "500",
      fontSize: "18px",
      color: "#fff",
      marginBottom: "19px",
    },
    "& button": {
      textAlign: "center",
      fontWeight: "600",
      width: "100%",
      background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
      borderRadius: "12px",
      height: "44px",
      color: "#fff",
      textDecoration: "none",
      textTransform: "capitalize",
      marginBottom: "20px",
      display: "block",
      position: "relative",
    },
    "& button.reminderSetbtn": {
      background: "transparent",
      border: "1px solid #fff",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        marginRight: "5px",
      },
    },
  },
  eventDate: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },
  eventFooter: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    color: "#fff",
    background: "#2F2860",
    padding: "10px 15px",
    margin: "0 -13px",
    fontWeight: "400",
    fontSize: "12px",
    "& a": {
      position: "relative",
      display: "inline-block",
      padding: "3px 9px",
      color: "#fff",
      fontWeight: "400",
      fontSize: "12px",
      background: "rgba(255, 255, 255, 0.2)",
      marginLeft: "7px",
      borderRadius: "6px",
    },
  },
  liveConnection: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    color: "#fff",
    fontWeight: "500",
    fontSize: "12px",
    marginBottom: "20px",
  },
  modalContainer: {
    position: "relative",
    display: "block",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "465px",
    background: "#fff",
    borderRadius: "8px",
    padding: "30px 22px 15px",
    "& h4": {
      fontSize: "24px",
      fontWeight: "700",
      color: "#000",
      width: "100%",
      textAlign: "left",
      marginBottom: "8px",
    },
    "& span": {
      position: "relative",
      display: "block",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "22px",
      textAlign: "center",
      marginBottom: "24px",
    },
    "& img": {
      textAlign: "center !important",
      position: "absolute !important",
      top: "10px !important",
      right: "10px !important",
      cursor: "pointer !important",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },

  modalBtnContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      position: "relative",
      textAlign: "center",
      display: "block",
      width: "180.5px ",
      maxWidth: "180px",
      padding: "8px 20px",
      height: "44px",
      margin: "0 12px",
      textTransform: "capitalize",
      borderRadius: "8px",
      border: "1px solid transparent",
      fontWeight: "600",
      fontSize: "14px",
    },
  },
  btnCancel: {
    borderColor: "#4f4f4f !important",
    color: "#4f4f4f !important",
  },
  btnDeleteMessgae: {
    border: "none !important",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    color: "#fff !important",
  },
  communityDropdown: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "& >div": {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },
  },
  communitydropdescription: {
    width: "100%",
    display: "none",
    "&.active": {
      display: "block",
    },
    "& p": {
      color: "#fff",
      fontWeight: "600",
      fontSize: "16px",
      fontStyle: "italic",
      margin: "8px 0px 27px",
    },
    "& img": {
      width: "16px !important",
    },
  },
  modalContainerbanuser: {
    position: "relative",
    display: "block",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "465px",
    background: "#fff",
    borderRadius: "8px",
    padding: "30px 22px 15px",
    "& h4": {
      fontSize: "24px",
      fontWeight: "700",
      color: "#000",
      width: "100%",
      textAlign: "left",
      marginBottom: "8px",
    },
    "& span": {
      position: "relative",
      display: "block",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "22px",
      marginBottom: "24px",
    },
    "& img": {
      textAlign: "center !important",
      position: "absolute !important",
      top: "10px !important",
      right: "10px !important",
      cursor: "pointer !important",
    },
    "@media(max-width:480px)": {
      width: "90%",
    },
  },
}));

const CommunityList = ({
  isMobile,
  goTo,
  setCommunityTitle,
  community,
  channel,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const router = useRouter();
  const r = auth();
  const [currentCommunity, setCurrentCommunity] = useState(null);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [communities, setCommunities] = useState([]);
  const [openRule, setOpenRule] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [show, setShow] = useState(false);
  const [userbanpopup, setUserbanpopup] = useState(false);
  const [count, setCount] = useState(0);
  const [announesementMessageId, setAnnounesementMessageId] = useState();

  const [open2, setOpen2] = useState(false);
  const { profile, isLoggedIn, id } = useSelector((state) => state.user);
  const { displayAnnouncement } = useSelector((state) => state.home);
  // console.log("displayAnnouncement", displayAnnouncement);
  const [loadingCountList, setLoadingCountList] = useState(true);
  const [totalLiveEvents, setTotalLiveEvents] = useState([]);
  const [announcementMessage, setAnnouncementMessage] = useState();
  const [communityIndex, setCommunityIndex] = useState();
  const [isActive, setIsActive] = useState(false);
  const currentChannelCommunityState = useSelector(
    (state) => state.community.currentChannel
  );
  const currentCommunityState = useSelector((state) => state.community.current);
  const { userData } = useSelector((state) => state.user);

  const {
    unreadMessageNotifications,
    communityNameDetails,
    eventReminder,
    announcementId,
    announcementPopupClick,
  } = useSelector((state) => state.community);

  // console.log(
  //   "Print communityNameDetails vakue after store redux: \n",
  //   communityNameDetails,
  //   announcementPopupClick
  // );

  const { data: communitiesData } = useQuery(`/v1/community`, () =>
    fetcher.get(`/v1/community`)
  );
  const { mutate: getCommunityChannnels } = useMutation((id) =>
    fetcher.get(`/v1/community/${id}/community-channel`)
  );
  const { mutate: joinCommunity } = useMutation((id) =>
    fetcher.post(`/v1/community/${id}/join`)
  );

  useEffect(() => {
    console.log("called", community, channel, communitiesData);
    if (community && channel && communitiesData) {
      const _find = communitiesData.results.find((obj) => obj.id == community);

      if (
        currentCommunityState &&
        _find &&
        (_find.id != currentCommunityState.id ||
          channel != currentChannelCommunityState._id)
      )
        getChannels(_find, channel);
    }
  }, [community, channel, communitiesData]);

  useEffect(() => {
    if (currentCommunityState) {
      setCurrentCommunity(currentCommunityState);
    }
  }, [currentCommunityState]);
  // console.log("communityNameDetails shitmax", communityNameDetails);
  useEffect(() => {
    if (communitiesData && communitiesData?.results) {
      setCommunities(communitiesData?.results);
      // console.log(
      //   "Print useEffect after recive data setCommunityNameDetails :\n",
      //   communitiesData?.results
      // );
      dispatch(setCommunityNameDetails(communitiesData?.results));

      if (!currentCommunity) {
        if (!community && !isMobile) {
          let _lastCommunity = localStorage.getItem("lastVisitedCommunity");
          const _find = communitiesData?.results.find(
            (obj) => obj.id == _lastCommunity
          );
          selectCommunity(_find || communitiesData?.results[0]);
        } else {
          const _find = communitiesData?.results.find(
            (obj) => obj.id == community
          );
          if (_find) getChannels(_find, channel);
        }
      } else {
        router.push(
          `/community/${currentCommunity.id}/${currentChannelCommunityState?._id}`,
          undefined,
          {
            shallow: true,
          }
        );
      }
    }
  }, [communitiesData, isMobile]);

  const getChannels = (item, channel) => {
    console.log("Print getChannels item == ", item);
    console.log("fetch channels", channel);

    getCommunityChannnels(item.id, {
      onSuccess: (res) => {
        // setOpen1(true);
        console.log("fetch channels");
        dispatch(
          setCommunityAndChannel({
            current: item,
            channels: res.result,
            channel: channel,
          })
        );
        if (isMobile) {
          setCommunityTitle(item?.attributes?.community_name);
          goTo("message");
        }
        let _vc = JSON.parse(localStorage.getItem("visitCommunity") || "{}");
        router.push(
          `/community/${item.id}/${
            channel
              ? channel
              : _vc[item.id]
              ? _vc[item.id]._id
              : res.result[0]._id
          }`,
          undefined,
          {
            shallow: true,
          }
        );
      },
      onError: (err) => {
        setSelectedCommunity(item);
        if (item?.isPremium == true) {
          setOpenRule(false);
          setOpen(true);
        } else {
          setOpenRule(true);
        }
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose1 = () => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("communitypopup", "clicked");
    }
    setOpen1(false);
  };

  const handleOpen1 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  useEffect(() => {
    const temp =
      typeof window !== "undefined"
        ? window?.sessionStorage.getItem("communitypopup")
        : false;
    console.log("temp", temp);
  }, []);

  useEffect(() => {
    if (userData?.community_status?.banned) {
      setUserbanpopup(true);
    }
  }, [userData?.community_status]);

  const selectCommunity = (item) => {
    localStorage.setItem("CommuntiyName", item?.attributes?.community_name);
    getChannels(item);
    dispatch(setShowThread(false));
  };
  const handleAgree = (isAgree) => {
    if (isAgree) {
      joinCommunity(selectedCommunity.id, {
        onSuccess: () => {
          setOpenRule(false);
          getChannels(selectedCommunity);
        },
        onError: () => {
          setOpenRule(false);
        },
      });
    } else setOpenRule(false);
  };

  const getCommunityUnreadMessageCount = (list, id) => {
    if (list.length) {
      let items = list.filter((item) => item?.communityId == id);
      return items.length
        ? items?.reduce((prevSum, item) => prevSum + item.count, 0)
        : 0;
    }
    return 0;
  };

  const { mutate: getLastSeen } = useMutation(
    (id) => fetcher.get(`v1/user/last-seen`),
    {
      onSuccess: (response) => {
        let channelWiseUreadCount = [];
        response?.result?.map((item) => {
          item?.channel?.map((data) => {
            channelWiseUreadCount.push({
              communityId: item?.communityId,
              ...data,
              count: data?.unreadCount,
            });
          });
        });
        dispatch(setUnreadMessageNotifications(channelWiseUreadCount));
        setLoadingCountList(false);
      },
      onError: (error) => {
        console.log("error", error);
        setLoadingCountList(false);
      },
    }
  );

  const [listMessage, setListMessage] = useState([]);
  const [threadinfo, setTthreadinfo] = useState([]);
  const [communityChannelList, setCommunityChannelList] = useState([]);
  const [userNftcollection, setUserNftcollection] = useState([]);
  const [hindiCommunityAnnouncement, setHindiCommunityAnnouncement] = useState(
    []
  );

  // // get hitPredtior List
  const { mutate: getHitpreditorList } = useMutation(
    (data) =>
      fetcher.get(
        `v1/message?limit=1&type=predictor&channelId=62457b2130977b263c6cf4c0`
      ),
    {
      onSuccess: (res) => {
        // console.log("Print response: ", res);
        setListMessage(res?.result);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  // get ThreadDetails
  const { mutate: getThreadDetails } = useMutation(
    (data) =>
      fetcher.get(
        `v1/community/6245680d3379a7ea6c377a74/community-channel/62457b2130977b263c6cf4c0/thread?limit=100`
      ),
    {
      onSuccess: (res) => {
        // console.log("Print Community details: ", res);
        setTthreadinfo(res?.result);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  // Get Community Channel List
  const { mutate: getCommunityChannelList } = useMutation(
    (data) =>
      fetcher.get(
        `/v1/message?channelId=62457b3030977b263c6cf4c4&limit=1&updateLastSeen=true`
      ),
    {
      onSuccess: (res) => {
        // console.log("Print getCommunityChannelList details: ", res);
        setHindiCommunityAnnouncement(res?.result);
        setAnnounesementMessageId(res?.result[0]?._id);
        if (announcementId == res?.result[0]?._id) {
          if (announcementPopupClick < 2) {
            setOpen1(true);
          }
          dispatch(setAnnouncementPopupClick(announcementPopupClick + 1));
        } else {
          dispatch(setAnnouncementId(res?.result[0]?._id));
          dispatch(setAnnouncementPopupClick(1));
          setOpen1(true);
        }
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  const { mutate: getAnnouncemtMessageList } = useMutation(
    (data) => fetcher.get(`v1/message?channelId=${data}`),
    {
      onSuccess: (res) => {
        setAnnouncementMessage(res?.result?.[0]?.originalText);
        console.log(
          "Print announcement Value :",
          res?.result?.[0]?.originalText
        );
      },
      onError: (err) => {
        console.log("Print announcement Error :", err);
      },
    }
  );

  const { mutate: reserveNftdata } = useMutation(
    () =>
      fetcher.get(`v1//nft/`, {
        params: {
          [`sortBy`]: "createdAt",
          populate: "*",
        },
      }),
    {
      onSuccess: (res) => {
        setUserNftcollection(res?.result);
      },
    }
  );

  const { mutate: getDisplayEvents } = useMutation(
    `v1/event`,
    () => fetcher.get(`v1/event`),
    {
      onSuccess: (res) => {
        console.log("Find Result for All Event", res?.result);
        const filterCommunityName = res?.result.map((item) => {
          console.log("map data communityNameDetails", communityNameDetails);
          let data = communityNameDetails.filter((comItem) => {
            return item?.communityId == comItem?.id;
          });
          console.log("data got", data);
          if (data?.length) {
            return { ...item, communityData: data[0] };
          } else {
            return { ...item, communityData: null };
          }
        });

        setTotalLiveEvents(filterCommunityName);
        console.log("Print filterCommunityName details: ", filterCommunityName);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  const { mutate: ReminderEventUser } = useMutation(
    (data) => fetcher.get(`v1/event/${data}/notifiy-me`),
    {
      onSuccess: (res) => {
        let eventId = localStorage.getItem("selectedEventID");
        console.log("setReminderSuccess", res, eventId, eventReminder);
        dispatch(setEventReminder([eventId, ...eventReminder]));
        getDisplayEvents();
      },
      onError: (err) => {
        console.log("setReminderFailed", err.response.data);
        console.log("error message setReminderEventUser ", err.response.data);
      },
    }
  );

  const handleSetRembinderEvent = (data) => {
    console.log("inside function data value print : \n", data);
    localStorage.setItem("selectedEventID", data?._id);

    const totalSolidNFT = userNftcollection?.filter(
      (item) => item?.txnStatus == "SOLD"
    );
    // console.log("inside function data value print : \n", totalSolidNFT);

    const nftHolderUserCommunity = communityNameDetails.filter(
      (item) => item?.isPremium == true
    );
    console.log("Print value nftHolderUserCommunity: ", nftHolderUserCommunity);

    if (nftHolderUserCommunity?.[0]?.isPremium == true) {
      if (totalSolidNFT.length > 0) {
        ReminderEventUser(data?._id);
      } else {
        setShow(true);
      }
    } else {
      ReminderEventUser(data?._id);
    }
  };

  const { mutate: getAnnouncementMessage } = useMutation(
    `v1/announcement`,
    () => fetcher.get(`v1/announcement`),
    {
      onSuccess: (res) => {
        console.log("Print getAnnouncementMessage details: ", res);
        const filterAnnouncemntMessage = res?.results?.filter((item) => {
          if (item?.type == "announcement") {
            return true;
          }
        });

        // const filterAnnouncemntMessage = res.results.find(
        //   (x) => x.type === "announcement"
        // );

        console.log("filterAnnouncemntMessage", filterAnnouncemntMessage);
        setCommunityChannelList(filterAnnouncemntMessage);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  useEffect(() => {
    getCommunityChannelList();
    getAnnouncementMessage();
    reserveNftdata();
    // console.log(
    //   "communityNameDetails value : ",
    //   communityNameDetails,
    //   communityNameDetails?.length
    // );
    if (communityNameDetails?.length > 0) {
      getDisplayEvents();
    }
  }, [communityNameDetails]);

  useEffect(() => {
    getHitpreditorList(currentChannelCommunityState?._id);
  }, [currentChannelCommunityState]);

  useEffect(() => {
    let communityId = get(currentCommunity, "id", null);
    let channelId = get(currentChannelCommunityState, "_id", null);
    if (communityId != null && channelId != null) {
      getThreadDetails();
    }
  }, [currentChannelCommunityState, currentCommunity]);

  useEffect(() => {
    setLoadingCountList(true);
    dispatch(setUnreadMessageNotifications([]));
    getLastSeen();
    // getThreadDetails();
  }, []);

  const openHitPredtior = (item) => {
    console.log("item valuse", item?.threadId);
    router.push("/community/6245680d3379a7ea6c377a74/62457b2130977b263c6cf4c0");

    let threadDetails = threadinfo?.filter(
      (data) => data?._id == item?.threadId
    );
    if (threadDetails.length) {
      let threadItem = threadDetails[0];
      console.log("pankaj", threadItem?._id, threadItem);
      dispatch(setThreadDetails({ meta: threadItem }));
      dispatch(setSelectedThread(threadItem?._id));
      setTimeout(() => {
        dispatch(setShowThread(true));
      }, 1000);

      if (isMobile) {
        goTo("member");
      }
    }
  };

  // console.log("Print listMessage", listMessage);
  const [userDetails, setUserDetails] = useState(null);
  const [communityrefLink, setCommunityrefLink] = useState("");
  const { mutate: getProfile } = useMutation(
    (id) => fetcher.get(`/v1/user/${profile?.id || id}`),
    {
      onSuccess: (response) => {
        console.log("Print user deytails", response);
        dispatch(setUserData(response?.result));
        dispatch(
          setUserDetail({
            ...profile,
            referralId: response?.result?.referralId,
          })
        );
        setCommunityrefLink(
          `${WEB_URL}/community/?ic=${response?.result?.referralId?.refCode}`
        );
      },
      onError: (error) => {
        setNameUpdateError(true);
      },
    }
  );

  useEffect(async () => {
    console.log("isLoggedIn", r?.token);
    if (r?.token) {
      if (typeof window !== "undefined") {
        let userId = localStorage.getItem("userId");
        getProfile(userId);
      }
    } else {
      setCommunityrefLink("Please login to get referal link");
    }
  }, [isLoggedIn]);

  // console.log("setCommunityrefLink :", communityrefLink);
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(communityrefLink);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 500);
    }
  }, [copied]);

  const buttonPropsSecond = {
    url: communityrefLink,
  };

  const iconProps = {
    size: 46,
    round: true,
  };

  const buttonProps = {
    url: communityrefLink,
    quote: " Own music and earn Royalty Income on FanTiger",
    hashtag: "#FanTiger",
  };

  const hasEventLiveEnded = (endDate) => {
    const today = new Date();
    const endsAt = new Date(endDate);
    const todayInGmt = new Date(today.toUTCString());
    if (endsAt.getTime() - todayInGmt.getTime() < 0) {
      return true;
    } else {
      return false;
    }
  };

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: true,
    arrows: false,
  };

  const checksetRembinderBtn = (item) => {
    if (eventReminder?.length) {
      return eventReminder.includes(item);
    } else return false;
  };

  const EventDisPlayForHitPundit = (data) => {
    const isLiveEventEnded = hasEventLiveEnded(data?.data?.timestamp);
    console.log("isLiveEventEnded value and timestamp: ", data);

    const handleNftholderCommunmity = () => {
      const totalSolidNFT = userNftcollection?.filter(
        (item) => item?.txnStatus == "SOLD"
      );

      const nftHolderUserCommunity = communityNameDetails.filter(
        (item) => item?.isPremium == true
      );
      // console.log(
      //   "Print value nftHolderUserCommunity: ",
      //   nftHolderUserCommunity,
      //   totalSolidNFT
      // );

      if (nftHolderUserCommunity?.[0]?.isPremium == true) {
        if (totalSolidNFT.length > 0) {
          router.push(
            `/community/${data?.data?.communityId}/${data?.data?.channelId}`
          );
        } else {
          setShow(true);
        }
      } else {
        router.push(
          `/community/${data?.data?.communityId}/${data?.data?.channelId}`
        );
      }
    };

    return (
      <>
        <div>
          <Box className={classes.eventReminder}>
            <Box className={classes.eventDate}>
              {isLiveEventEnded == false ? (
                <>
                  <Typography component="small">
                    <Box component="img" src="/images/community/calendar.svg" />
                    {moment(data?.data?.timestamp).format(
                      "DD MMM, h:mm A"
                    )}. {data?.data?.peopleGointCount} Going
                  </Typography>
                  {/* <Box component="img" src="/images/community/upload.svg" /> */}
                </>
              ) : (
                <>
                  <Typography component="small">
                    <Box
                      component="img"
                      src="/images/community/live-signal.svg"
                    />
                    Live
                  </Typography>
                </>
              )}
            </Box>
            {isLiveEventEnded == false ? (
              <Typography component="p">{data?.data?.title}</Typography>
            ) : (
              <Typography
                component="p"
                style={{ cursor: "pointer" }}
                onClick={() => handleNftholderCommunmity()}
              >
                {data?.data?.title}
              </Typography>
            )}
            {isLiveEventEnded == false ? (
              <>
                {data?.data?.isReminderSet == false ? (
                  <Button
                    onClick={() => {
                      handleSetRembinderEvent(data?.data);
                    }}
                  >
                    Set Reminder
                  </Button>
                ) : (
                  <Button
                    // onClick={() => handleSetRembinderEvent(data?.data)}
                    className="reminderSetbtn"
                    disabled
                  >
                    <Box
                      component="img"
                      src="/images/community/eventrembinder.svg"
                      style={{ width: "16px", height: "16px" }}
                    />
                    Reminder Set
                  </Button>
                )}
              </>
            ) : (
              <>
                {/* <Box className={classes.liveConnection}>
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail.png"
                  />
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail-2.png"
                  />
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail-3.png"
                  />
                  {data?.data?.peopleGointCount} active
                </Box> */}
              </>
            )}

            <Box className={classes.eventFooter}>
              <Box
                component="img"
                src={
                  data?.data?.communityData?.attributes?.community_icon?.data
                    ?.attributes?.url
                }
              />
              {data?.data?.communityData?.attributes?.community_name}
              {isLiveEventEnded == false ? (
                <Link disable={true}>Host</Link>
              ) : (
                <Link
                  style={{ cursor: "pointer" }}
                  onClick={() => handleNftholderCommunmity()}
                >
                  Host
                </Link>
              )}
            </Box>
          </Box>
        </div>
        {/* <div>
              <Box className={classes.eventReminder}>
                <Box className={classes.eventDate}>
                  <Typography component="small">
                    <Box
                      component="img"
                      src="/images/community/live-signal.svg"
                    />
                    Live
                  </Typography>
                </Box>
                <Typography component="p">
                  Lorem ipsum dolor sit amet, consectetu
                </Typography>
                <Box className={classes.liveConnection}>
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail.png"
                  />
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail-2.png"
                  />
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail-3.png"
                  />
                  100 active
                </Box>
                <Box className={classes.eventFooter}>
                  <Box
                    component="img"
                    src="/images/community/profile-thumbnail-3.png"
                  />
                  FanTiger
                  <Link href="#">Host</Link>
                </Box>
              </Box>
            </div> */}
      </>
    );
  };

  return (
    <>
      <nav className={isMobile ? `community_list mobile` : `community_list`}>
        <div
          style={{
            color: "#FFF",
            paddingBottom: "10px",
            // background: "#00000066",
            top: "0px",
            cursor: "pointer",
          }}
          onClick={() => {
            // router.back();
            router.push("/");
          }}
        >
          <Typography
            component="h1"
            style={{ fontSize: "12px", fontWeight: "600" }}
          >
            <img
              src="/images/community/errowsign.svg"
              style={{
                paddingRight: "10px",
                width: "20px",
              }}
            />
            Back to Main Website
          </Typography>
        </div>
        {/* {currentChannelCommunityState?._id == "62457b2130977b263c6cf4c0" ? ( */}

        <div style={{ paddingVertical: "5px", marginBottom: "-15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span
              style={{
                fontSize: "26px",
                fontWeight: "600",
                color: "#FFF",
                // paddingBottom: "10px",
                display: "block",
                position: "relative",
              }}
            >
              Community
            </span>

            <a
              href="#"
              className="btn-invite-earn"
              onClick={() => {
                handleOpen1();
              }}
            >
              Invite & Earn
            </a>
          </div>
          <br />
        </div>

        {/* =======Event Section Start======= */}
        {totalLiveEvents && totalLiveEvents?.length > 0 && (
          <>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#FFF",
                paddingBottom: "10px",
                display: "block",
                position: "relative",
              }}
            >
              Events
            </span>
            <Box className={classes.eventContainer}>
              <Slider {...settings}>
                {totalLiveEvents?.length > 0 &&
                  totalLiveEvents?.map((item, index) => {
                    return <EventDisPlayForHitPundit data={item} key={index} />;
                  })}
              </Slider>
            </Box>
          </>
        )}

        {/* =======Event Section End======= */}
        <Box>
          <span
            style={{
              fontSize: "16px",
              fontWeight: "500",
              display: "block",
              position: "relative",
              width: "100%",
              color: "#FFF",
              paddingBottom: "10px",
            }}
          >
            Communities
          </span>
          <span
            style={{
              fontSize: "12px",
              color: "#FFF",
              paddingVertical: "5px",
              display: "block",
              position: "relative",
              width: "100%",
              marginBottom: "10px",
            }}
          >
            Discuss all things music, artists, nft, etc
          </span>
        </Box>

        <ul>
          {communities &&
            communities.length > 0 &&
            communities.map((item, index) => {
              let unreadNotification = !loadingCountList
                ? getCommunityUnreadMessageCount(
                    unreadMessageNotifications,
                    item?.id
                  )
                : 0;

              // console.log(
              //   "Print Community Details Id value",
              //   item?.id,
              //   item?.community_channel?.[1]?._id
              // );

              return (
                <li
                  key={index}
                  className={
                    currentCommunity && currentCommunity.id === item.id
                      ? "active"
                      : ""
                  }
                  style={{
                    borderBottom: "1px solid rgba(220, 224, 228, 0.15)",
                  }}
                >
                  <div
                    className="info list-hint"
                    onClick={(e) => {
                      songPageGTMCTAClick(
                        r,
                        item?.attributes?.community_name,
                        "",
                        item?.attributes?.community_name,
                        "loggedIn",
                        "Guest"
                      );
                      setIsActive(!isActive);
                      setCommunityIndex(item?.community_channel?.[1]?._id);
                      selectCommunity(item);
                      getAnnouncemtMessageList(
                        item?.community_channel?.[1]?._id
                      );
                    }}
                    aria-label={item?.attributes?.community_description}
                  >
                    <Box className={classes.communityDropdown}>
                      <Box>
                        <div
                          style={{ position: "relative", marginRight: "15px" }}
                        >
                          <img
                            src={
                              item?.attributes?.community_icon?.data?.attributes
                                ?.url
                            }
                            alt={
                              item?.attributes?.community_icon?.data?.attributes
                                ?.alternativeText
                            }
                          />
                          {item?.attributes?.isExclusive && (
                            <img
                              src="/images/community/lock.svg"
                              alt=""
                              style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                maxWidth: "28px",
                                maxHeight: "28px",
                              }}
                            />
                          )}
                        </div>
                        <div className="details">
                          <div className="name_tag">
                            <span
                              className="name"
                              data-toggle="tooltip"
                              data-placement="right"
                              // title={
                              //   item?.attributes?.community_name &&
                              //   item?.attributes?.isExclusive
                              //     ? item?.attributes?.community_name +
                              //       " " +
                              //       "(Exclusive)"
                              //     : item?.attributes?.community_name
                              // }
                            >
                              {item?.attributes?.community_name &&
                              item?.attributes?.isExclusive
                                ? item?.attributes?.community_name +
                                  " " +
                                  "(Exclusive)"
                                : item?.attributes?.community_name}
                            </span>
                            {item?.attributes?.isTrending && (
                              <span className="trending">Trending</span>
                            )}
                          </div>
                          <span className="member_count">
                            {/* {item?.attributes?.member_count
                          ? item?.attributes?.member_count
                          : "0"}{" "} */}
                            {/* {item?.memberCount} Members */}
                          </span>
                        </div>
                      </Box>
                      {/* <Box
                        component="img"
                        src="/images/community/arrows1.svg"
                        width="24px"
                        height="24px"
                        style={{ marginRight: "-21px" }}
                        // onClick={() => {}}
                      /> */}
                    </Box>
                    {/* <Box
                      className={
                        isActive === true &&
                        communityIndex === item?.community_channel?.[1]?._id
                          ? classes.communitydropdescription + " active"
                          : classes.communitydropdescription + ""
                      }
                      onClick={() =>
                        router.push(
                          `/community/${item?.id}/${item?.community_channel?.[1]?._id}`
                        )
                      }
                    >
                      <Typography component="p">What&#39;s new</Typography>
                      <Typography component="p">
                        <img src="/images/community/🚨.png" />{" "}
                        {announcementMessage?.slice(13, 40)}{" "}
                        <img src="/images/community/🚨.png" />
                      </Typography>
                      <Box className={classes.liveConnection}>
                        {announcementMessage?.slice(40, 260)}{" "}
                      </Box>
                    </Box> */}
                  </div>
                  {unreadNotification && currentCommunity?.id !== item?.id ? (
                    <Box
                      sx={{
                        background:
                          "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
                        height: "30px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        padding: "6px 10px 0px 10px",
                        borderRadius: "15px",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#FFF",
                          fontSize: "16px",
                          fontWeight: "500",
                          lineHeight: "18px",
                        }}
                      >
                        {unreadNotification > 100 ? "100+" : unreadNotification}
                      </Typography>
                    </Box>
                  ) : (
                    <></>
                  )}
                  <MoreAction />
                </li>
              );
            })}
        </ul>
        <CommunityRuleAgreeModal
          open={openRule}
          communityRules={selectedCommunity?.attributes?.community_rules}
          agree={handleAgree}
          isExclusive={selectedCommunity?.attributes?.isExclusive}
        />
        <Modal open={open} onClose={handleClose} disableScrollLock={true}>
          <Box
            style={{
              position: "relative",
              display: "block",
              width: "100%",
              maxWidth: "512px",
              background: "#fff",
              margin: "auto",
              padding: "40px 40px",
              borderRadius: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              "@media(max-width:767px)": {
                width: "90%",
                maxHeight: "615px",
                padding: "15px",
              },
            }}
          >
            <button
              type="button"
              className=" close"
              style={{
                zIndex: "2",
                position: "absolute",
                top: "15px",
                right: "15px",
              }}
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            >
              <span aria-hidden="true">
                <img
                  src="/images/community/modal-close.svg"
                  style={{ width: "18px", height: "18px" }}
                />
              </span>
            </button>
            <Box>
              <Box>
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  Exclusive Community : Needs Access
                </Typography>
                <Box>
                  <Typography variant="p">
                    This community is for the holders of FanTiger Music NFTs and
                    you will need to buy a NFT to get access to this community.
                    <br></br>
                    <a
                      href="/nft/9-9-mashukan"
                      style={{ color: "#E14084", textDecoration: "none" }}
                    >
                      {" "}
                      Click here to buy a NFT.
                    </a>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
        {/* for Announcement pop up */}
        {/* {displayAnnouncement == true && ( */}
        <Modal open={open1} onClose={handleClose1} disableScrollLock={true}>
          <Box className={classes.msgOverflowScroll}>
            <button
              type="button"
              className=" close"
              style={{
                zIndex: "2",
                position: "absolute",
                top: "15px",
                right: "15px",
              }}
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose1}
            >
              <span aria-hidden="true">
                <img
                  src="/images/community/modal-close.svg"
                  style={{ width: "18px", height: "18px" }}
                />
              </span>
            </button>
            <Box>
              <Box>
                <Typography
                  variant="h4"
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  Announcement{" "}
                  <img
                    src="/images/community/announcement1.png"
                    width="25px"
                    height="25px"
                  />
                  :
                </Typography>
                <Box>
                  {communityChannelList?.length > 0 ? (
                    <Box>
                      <Typography>
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                          {communityChannelList[0]?.text}
                        </ReactMarkdown>
                      </Typography>
                    </Box>
                  ) : (
                    hindiCommunityAnnouncement.length > 0 &&
                    hindiCommunityAnnouncement.map((item) => {
                      console.log("Print hindiCommunityAnnouncement: ", item);
                      return (
                        <Box key={item?.id}>
                          <Typography>
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                              {item?.text}
                            </ReactMarkdown>
                          </Typography>
                        </Box>
                      );
                    })
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
        {/* )} */}

        <Modal open={open2} onClose={handleClose2} disableScrollLock={true}>
          <Box className={classes.invitePopupBox}>
            <Link
              href="#"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose2}
            >
              <Box component="img" src="/images/community/close.svg" />
            </Link>
            <Box className={classes.inviteHeader}>
              <Box
                component="img"
                src="/images/community/invitecommunity1.gif"
                style={{ width: "80px", height: "80px" }}
              />
              <Box>
                <Typography variant="h4">Invite & Earn!</Typography>
                <Typography component="p">
                  Invite friends to join community & Earn FanTiger Coins
                </Typography>
              </Box>
            </Box>
            <Box className={classes.inviteBody}>
              <Box>
                <Typography component="span">How it works?</Typography>
                <List>
                  <ListItem>
                    Invite a friend to join community at FanTger
                  </ListItem>
                  <ListItem>
                    That friend joins and engages in the community
                  </ListItem>
                  <ListItem>
                    After their first engagement, you will earn 500 FanTiger
                    Coins
                  </ListItem>
                </List>
              </Box>
            </Box>
            <Box className={classes.inviteFooter}>
              <Box>
                <Typography component="span">Share Link</Typography>
                <Box
                  className={classes.linkContainer}
                  onClick={copyToClipboard}
                >
                  <Link href="#">{communityrefLink}</Link>
                  {isLoggedIn ? (
                    <>
                      {copied ? (
                        <Typography variant="h6" className={classes.copied}>
                          Copied
                        </Typography>
                      ) : (
                        <IoCopyOutline size={24} color="#E14084" />
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </Box>
                <Typography component="span">Share Via</Typography>
                <Box className={classes.socialContainer}>
                  <WhatsappShareButton {...buttonPropsSecond}>
                    <WhatsappIcon {...iconProps} />
                    <Typography component="p">Whatsapp</Typography>
                  </WhatsappShareButton>

                  <TwitterShareButton
                    {...buttonPropsSecond}
                    style={{ marginLeft: "20px", cursor: "pointer" }}
                  >
                    <TwitterIcon {...iconProps} />
                    <Typography component="p">Twitter</Typography>
                  </TwitterShareButton>

                  <FacebookShareButton
                    {...buttonProps}
                    style={{ marginLeft: "20px", cursor: "pointer" }}
                  >
                    <FacebookIcon {...iconProps} />
                    <Typography component="p">Facebook</Typography>
                  </FacebookShareButton>

                  <TelegramShareButton
                    url={
                      communityrefLink
                        ? "Own music and earn Royalty Income on FanTiger  " +
                          communityrefLink
                        : ""
                    }
                    style={{ marginLeft: "15px", cursor: "pointer" }}
                  >
                    <TelegramIcon {...iconProps} />
                    <Typography component="p">Telegram</Typography>
                  </TelegramShareButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>

        {/* NFT Popup */}
        <Modal
          open={show}
          onClose={() => setShow(false)}
          disableScrollLock={true}
        >
          <Box className={classes.modalContainer}>
            <Box
              component="img"
              src="/images/payment/popup-close.svg"
              sx={classes.btnClose}
              width="24"
              height="24"
              onClick={() => setShow(false)}
            />
            <Typography variant="h4">Reminder</Typography>
            <Typography component="span">
              This event is only for NFT Holder Community. Please buy NFT to
              attend the event.
            </Typography>

            <Box className={classes.modalBtnContainer}>
              <Button
                onClick={() => router.push("/nft/9-9-mashukan")}
                className={classes.btnDeleteMessgae}
              >
                Buy NFT
              </Button>
              <Button
                className={classes.btnCancel}
                contained="solid"
                onClick={() => setShow(false)}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* user Ban popup */}
        <Modal
          open={userbanpopup}
          onClose={() => setUserbanpopup(false)}
          disableScrollLock={true}
        >
          <Box className={classes.modalContainerbanuser}>
            <Box
              component="img"
              src="/images/payment/popup-close.svg"
              sx={classes.btnClose}
              width="24"
              height="24"
              onClick={() => setUserbanpopup(false)}
            />
            <Typography variant="h4" style={{ textAlign: "center" }}>
              Alert{" "}
            </Typography>
            <Typography
              style={{ textAlign: "left", fontWeight: "600" }}
              component="p"
            >
              Dear User,
            </Typography>
            <Typography component="span">
              {/* <b style={{ "text-align": "left" }}>Dear User,</b> */}
              {/* <br /> */}
              Your Account has been restricted for{" "}
              <b>
                {" "}
                {userData?.community_status?.banned_firsttime &&
                !userData?.community_status?.banned_secondtime &&
                !userData?.community_status?.banned_thirdtime
                  ? "2 Days"
                  : userData?.community_status?.banned_firsttime &&
                    userData?.community_status?.banned_secondtime &&
                    !userData?.community_status?.banned_thirdtime
                  ? "7 Days"
                  : "lifetime"}{" "}
              </b>
              and you will not be allowed to send message in communities due to
              violation of Community Flooding Rules.
            </Typography>

            <Box className={classes.modalBtnContainer}>
              <Button
                className={classes.btnDeleteMessgae}
                onClick={() => setUserbanpopup(false)}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Modal>
      </nav>
    </>
  );
};
export default CommunityList;
